const isLogin = () => {
    if(localStorage.getItem("token")){
        return true;
    }else{
         return false;
    }
}

exports.isLogin = isLogin;


// WEBPACK FOOTER //
// ./src/utils/authentication.js